import { ReactNode, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { authService } from '@/services/auth.service'

interface AuthGuardProps {
  children: ReactNode
}

export function AuthGuard({ children }: AuthGuardProps) {
  const navigate = useNavigate()
  const [isChecking, setIsChecking] = useState(true)
  const [isAuthenticated, setIsAuthenticated] = useState(false)

  useEffect(() => {
    const checkAuth = () => {
      const authenticated = authService.isAuthenticated()
      setIsAuthenticated(authenticated)
      
      if (!authenticated) {
        navigate('/login', { replace: true })
      }
      
      setIsChecking(false)
    }
    
    checkAuth()
  }, [navigate])

  // Show nothing while checking authentication to prevent flash of content
  if (isChecking) {
    return null
  }

  // Render children only if authenticated
  return isAuthenticated ? <>{children}</> : null
} 